import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Injectable()
@Pipe({ name: 'localeString' })
export class LocaleStringPipe implements PipeTransform {
  transform(val: any): string {
    if (val === null || val === undefined || Number.isNaN(val) || val === Infinity || typeof val !== 'number') {
      return 'N/A';
    } else {
      return val.toLocaleString();
    }
  }
}
